import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterLinkActive, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'odl-year-selector',
    templateUrl: './odl-year-selector.component.html',
    styleUrls: ['./odl-year-selector.component.scss']
})
export class OdlYearSelectorComponent implements OnInit, OnDestroy {

    private unsubscribe$ = new Subject<void>();

    years = [];
    currentYear = 2019;
    firstYear = 2010;
    lastyear = 2020;
    selectedYear: number;


    constructor(
        private route: ActivatedRoute,
    ) {
        const date = new Date();
        this.currentYear = date.getFullYear();
        this.lastyear = this.currentYear + 1;
    }

    ngOnInit() {
        for (let idx = this.lastyear; idx >= this.firstYear; idx--) {
            this.years.push(idx);
        }
        this.route.params
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(p => {
            this.selectedYear = parseInt(p.year, 0);
        });
        // this.selectedYear = parseInt(this.route.snapshot.params.year,0);
    }
    ngOnDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
